var _rect, _circle, _circle2, _path, _path2, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTankerIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 54,
    viewBox: "0 0 100 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 35,
    width: 100,
    height: 9,
    rx: 4,
    fill: "#29ABE2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 46,
    r: 8,
    fill: "#F7931E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 46,
    r: 8,
    fill: "#F7931E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67 2H87.0769L96 18.5V35H67V2Z",
    fill: "#29ABE2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73 6H84.7692L90 21H73V6Z",
    fill: "#F7931E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3,
    width: 61,
    height: 30,
    rx: 8,
    fill: "#F7931E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    width: 11,
    height: 3,
    fill: "#29ABE2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTankerIcon);
export default __webpack_public_path__ + "static/media/TankerIcon.8e2a62325be8a27794c0385b1cc40e58.svg";
export { ForwardRef as ReactComponent };